<div *ngIf="spinnerData" class="spinner-container" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="30px">
    <img alt="Loading" [src]="spinnerData.loading ? 'assets/loading-spinner.gif' : 'assets/loading-ok.gif'" class="animation">
    <div>{{spinnerData.loadingMessage}}</div>
</div>
